import type { ChannelMappingRow } from '../../unifiedcommerce/framework';

type Props = { mappings?: ChannelMappingRow[] };

export function ChannelMappingPanel({ mappings = [] }: Props) {
  return (
    <div className="space-y-2">
      {mappings.map((m) => (
        <div key={m.type} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{m.type}</p>
            <p className="mt-0.5 text-xs text-slate-500">{m.source}</p>
          </div>
          <div className="shrink-0 text-right">
            <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{m.mapped} mapped</p>
            {m.pending > 0 && <p className="text-xs text-warning-600">{m.pending} pending</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
